export default __webpack_public_path__ + "img/upgrade_bg_2-9b9d34094df66932d3dd8af18f40b770.png";